import axios from '../../utils/axios';

const baseUrl = `/api/changeLogs`;

export const fetchChangeLog = async (opportunityId: number) => {
  const requestUrl = `${baseUrl}/opportunity/${opportunityId}`;
  return await axios.get(requestUrl);
};
